import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import { OrderHistory } from '../../models/orderhistory'

import * as moment from 'moment'

@Component({
  selector: 'app-orderhistory-page',
  templateUrl: './orderhistory-page.component.html',
  styleUrls: ['./orderhistory-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderhistoryPageComponent {
  @Input() loading: boolean
  @Input() expanding: boolean
  @Input() orderHistory: OrderHistory[]
  @Input() currency: string

  @Output() onExpand = new EventEmitter<void>()

  constructor() { }

  get hasOrders(): boolean {
    return this.orderHistory.length > 0
  }

  orderedOn(input: Date): string {
    const date = moment(input)
    let retValue = ''

    if (date.isValid()) {
      retValue = moment(input).format('DD-MM-YYYY HH:mm')
    }

    return retValue
  }

  expand() {
    this.onExpand.emit()
  }
}
